import React, { useState, useEffect } from "react";
import { VictoryPie, VictoryLegend, VictorySharedEvents } from "victory";
import { COLORS } from "utils/styles.js";
import styled from "styled-components";

const P = styled.p`
  padding-top: 10px;
`;

export default function DonutGraph(props) {
  const { colors, data, extras } = props;

  var labelcount = 0;
  const defaultLabels = [];
  data.map((dataObj) => {
    const label = {
      name: `${dataObj.x} - ${dataObj.y}%`,
      color: dataObj.color,
      symbol: { type: "square" },
    };
    labelcount++;
    defaultLabels.push(label);
  });

  const [newColors, setColors] = useState(colors);
  useEffect(() => {
    setColors(colors);
  }, [colors]);
  const displayExtras = extras ? <P>{extras}</P> : null;

  return (
    <div>
      <VictorySharedEvents
        events={[
          {
            childName: ["pie", "bar"],
            target: "data",
            eventHandlers: {
              onMouseOver: () => {
                return [
                  {
                    childName: ["pie", "bar"],
                    mutation: (props) => {
                      setColors([COLORS.GRAY]);
                      return {
                        style: Object.assign({}, props.style, {
                          fill: props.datum.color,
                        }),
                      };
                    },
                  },
                ];
              },
              onMouseOut: () => {
                return [
                  {
                    childName: ["pie", "bar"],
                    mutation: () => {
                      setColors(colors);
                      return null;
                    },
                  },
                ];
              },
            },
          },
        ]}
      >
        <svg viewBox="0 0 250 220">
          <svg transform={"translate(0, 0)"}>
            <VictoryPie
              name="pie"
              data={data}
              width={250}
              height={250}
              standalone={false}
              colorScale={newColors}
              padAngle={3}
              innerRadius={50}
              cornerRadius={5}
              labels={({ datum }) => (datum.y >= 6 ? datum.initials : null)}
              style={{
                labels: {
                  fill: "white",
                  fontSize: 9,
                  pointerEvents: "none",
                },
              }}
              labelRadius={({ innerRadius }) => innerRadius + 20}
              padding={{ left: 25, top: -15, right: 25, bottom: 35 }}
            />
          </svg>
        </svg>
        <VictoryLegend
          colorScale={newColors}
          itemsPerRow={data.length > 5 ? 3 : 5}
          name="bar"
          width={365}
          gutter={30}
          rowGutter={{ top: 0, bottom: -5 }}
          height={Math.min(labelcount * 26, 110)}
          data={defaultLabels}
          standalone={true}
          style={{ labels: { fontSize: 12.5 } }}
        />
      </VictorySharedEvents>
      {displayExtras}
    </div>
  );
}
